import { Map } from 'immutable';

import { ADD } from './constants';

const initialState = Map();

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD:
      return action.stats;

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
